import { getToken, setToken, removeToken, getUserData, setUserData, removeUserData } from '@/utils/auth'
import { resetRouter } from '@/router'
import api from '@/services/api';
import { token } from 'morgan';

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    userData: getUserData()
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_DATA: (state, userData) => {
    state.userData = userData;
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { userName, password } = userInfo
    return new Promise((resolve, reject) => {
      let result = api.post(`/api/account/login`, { userName: userName.trim().toLowerCase(), password: password }).then(response => {
        const { data } = response;
        console.log(data)
        if (data.success) {
          commit('SET_TOKEN', data.token);
          commit('SET_USER_DATA', data.userData);
          setUserData(data.userData);
          setToken(data.token);
          resetRouter();
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  changePassword({ commit }, updateInfo) {
    return new Promise((resolve, reject) => {
      let result = api.put(`/api/account/change-account-password`, updateInfo).then(response => {
        const { data } = response;
        if (data.success) {
          resolve(data)
        } else {
          reject(data)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    // return new Promise((resolve, reject) => {
    //   getInfo(state.token).then(response => {
    //     const { data } = response

    //     if (!data) {
    //       return reject('Verification failed, please Login again.')
    //     }

    //     const { name, avatar } = data

    //     commit('SET_NAME', name)
    //     commit('SET_AVATAR', avatar)
    //     resolve(data)
    //   }).catch(error => {
    //     reject(error)
    //   })
    // })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
        removeToken() // must remove  token  first
        removeUserData()
        commit('RESET_STATE')
        resetRouter()
        resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

